export default {
    namespaced: true,
    state: {
        basket: false,
        checkout: false,
        user: false,
        address_book: false,
        payment_methods: false,
        checkout_calculations: true
    },
    getters: {
        is_ready: (state) => (id) => {
            return state[id];
        }
    },
    mutations: {
        is_ready(state, payload) {
            state[payload] = true;
        },
        is_not_ready(state, payload) {
            state[payload] = false;
        }
    },
    actions: {

    },
};